export default __webpack_public_path__ + "static/media/photo4.d10f5315.jpg";